import React from 'react';
import ApplicationsVersionsTableView from '../../views/applications/versions';
import UUID from 'uuid';
import CurrentApplicationLabel from './current-label';
import { AppCollection } from '../../services/collection';
import { withRouter } from "react-router-dom";

class ApplicationPermissionsTableScreen extends React.Component {

  state = {
    name: ''
  };

  onSave = async (data, setData) => {
    const input = {
      ...data,
      uuid: data.uuid || UUID.v4()
    };
    await setData({
      ...input
    });
  };

  onDelete = async (data, remove) => {
    if (!data.uuid) {
      return remove(data.uuid);
    }
    await remove(data.uuid);
  };

  getVersions() {
    const app = (this.props.apps || [])
      .find(({ uuid }) => this.props.match.params.uuid === uuid);
    return (app || {}).versions || [];
  }

  render() {
    return (
      <ApplicationsVersionsTableView
        name={(
          <React.Fragment>
            <CurrentApplicationLabel />&nbsp;Versions
          </React.Fragment>
        )}
        versions={this.getVersions()}
        onSave={this.onSave}
        onDelete={this.onDelete}
      />
    )
  }
}

const mapAppProps = ({ loading, list }) => ({ apps: list, appsLoading: loading });

const appConnect = AppCollection.connect(mapAppProps);

export default appConnect(
  withRouter(ApplicationPermissionsTableScreen)
);



// WEBPACK FOOTER //
// ./src/app/applications/versions.js